/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaNewsletterSubscribeViewProps } from './citta-newsletter-subscribe';

/**
 *
 * ICittaProductSkuView component
 * @extends {React.PureComponent<ICittaProductSkuViewProps>}
 */
export class ICittaNewsletterSubscribeView extends React.PureComponent<ICittaNewsletterSubscribeViewProps> {

    public render(): JSX.Element | null {
        const { SubscribeWrapper, subscribeResponse, subscribeForm, responseSuccess, userEmail } = this.props;
        const { FormWrapper, FormContainer, emailInput, checkboxPrivacyPolicy, subscribeButtton, reCaptcha, subscribeThanks } = subscribeForm;
        return (
            <Module {...SubscribeWrapper} >
                {subscribeResponse}
                <Node {...FormWrapper} >
                    <Node {...FormContainer} >
                        {emailInput}
                        {checkboxPrivacyPolicy}
                        {reCaptcha}
                        {responseSuccess ? subscribeThanks : subscribeButtton}
                        {userEmail}
                    </Node>
                </Node>
            </Module>
        );
    }
}
export default ICittaNewsletterSubscribeView;
